module.exports = __webpack_public_path__ + "img/ireland.8ba68351.png";